import SuccessMessage from './components/SuccessMessage';

const ForgotPassword = () => <SuccessMessage />;

export default ForgotPassword;
